export default {
  sidebar: 64,
  sidebar__collapsed: 80,
  sidebar__opened: 274,
  chat: 0,
  chat__opened: 382,
  header: 60,
  task_tracker: 76,
}
